/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Chkk API v1.0
 * Chkk API for Kubernetes deployment and upgrade safety.
 * OpenAPI spec version: v1.0
 */

/**
 * The type of Cloud Connection
 */
export type CloudType = (typeof CloudType)[keyof typeof CloudType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloudType = {
  AWS: 'AWS',
  GCP: 'GCP',
  AZURE: 'AZURE',
  OCI: 'OCI',
} as const;
